<template>
    <el-upload
        :class="{hide: this.hideUpload}"
        :action="this.$store.state.baseURL + 'UploadFile'"
        :on-exceed="handleExceed"
        :limit="limit"
        :on-preview="handlePreview"
        :before-upload="beforeUpload"
        :before-remove="beforeRemove"
        :on-remove="onRemove"
        :on-success="onSuccess"
        :file-list="fileList"
        :list-type="type"
        :headers="headers"
        :disabled="disabled"
        :style="upload_style"
    >
        <i v-if="type === 'picture-card'" class="el-icon-plus"></i>
        <img v-else-if="(type === 'picture') && (!this.hideUpload)" :src="$store.state.baseURL+'icon/tupian.png'" style="height: 20px;">
        <el-dialog
            :visible.sync="dialogVisible"
            :center="true"
            :append-to-body="true"
            width="300px"
        >
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </el-upload>
</template>

<script>
export default {
    name:'CommonUploadComponent',
    data(){
        return {
            fileList: [],
            dialogVisible: false,
            dialogImageUrl: '',
            headers: {
                Authorization: 'Bearer ' + sessionStorage.getItem('token')
            },
            hideUpload: false
        }
    },
    computed:{
        upload_style() {
            if(this.type === 'picture') {
                return 'display: inline;margin-left: 10px;'
            }

            return ''
        }
    },
    methods:{
        onSuccess(response, file, fileList) {
            if(response.status !==0) {
                this.$message.error(response.msg)
                return
            }

            if(fileList.length >= this.limit) {
                this.hideUpload = true
            }

            this.fileList.push({
                name: file.name,
                url: this.$store.state.baseURL + response.result.url
            })
        },
        handlePreview(file) {
            const name_arr = file.name.split('.');
            if((name_arr[name_arr.length-1] === 'jpg') || (name_arr[name_arr.length-1] === 'png') || (name_arr[name_arr.length-1] === 'gif')) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            } else {
                window.open(file.url, '_blank')
            }
        },
        handleExceed(files, fileList) {
            this.$message.warning(`最大允许上传`+this.limit+`个文件`)
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${ file.name }？`);
        },
        onRemove(file,fileList) {
            this.fileList = fileList
            if(this.fileList.length < this.limit) {
                this.hideUpload = false
            }
        },
        beforeUpload(file) {
            const arr = [
                'image/jpeg',   //JPG图片
                'image/png',    //PNG图片
                'image/gif'     //GIF图片
                // 'application/msword',   //doc格式word
                // 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',   //docx格式word
                // 'application/vnd.ms-excel',     //xls格式表格
                // 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',    //xlsx格式表格
                // 'application/vnd.ms-powerpoint',    //ppt格式幻灯片
                // 'application/vnd.openxmlformats-officedocument.presentationml.presentation',    //pptx格式幻灯片
                // 'text/plain',   //txt文本
                // 'application/pdf'   //pdf
            ]
            const InArr = (arr.indexOf(file.type) > -1)
            const OverStepSize = (file.size / 1024 / 1024 < 5)

            if (!InArr) {
                this.$message.error('超出可上传文件类型!')
                return
            }
            if (!OverStepSize) {
                this.$message.error('超出可上传文件大小')
                return
            }

            return InArr && OverStepSize;
        }
    },
    filters:{},
    props:{
        ffileList: {
            type: Array,
            default() {
                return []
            }  
        },
        disabled: {
            type: Boolean,
            default() {
                return false
            }
        },
        limit: {
            type: Number,
            default() {
                return 3
            }
        },
        type: {
            type: String,
            default() {
                return 'picture-card'
            }
        }
    },
    created(){},
    destoryed(){},
    mounted(){},
    updated(){},
    components:{},
    watch:{
        ffileList(newVal) {
            this.fileList = newVal
        }
    }
}
</script>

<style lang='less'>
.hide .el-upload--picture-card {
    display: none;
}
</style>